import { Loader2, Lock } from "lucide-react";
import PlansPanel from "./PlansPanel";
import useSubscriptionAccess from "../hooks/useSubscriptionAccess";

/**
 * Blocks a page until the account has an active subscription (or an
 * admin-granted exemption). Renders the pricing panel inline instead of the
 * locked page so the user can subscribe without leaving the spot.
 */
const SubscriptionGate = ({ children }) => {
  const { loading, hasAccess, refresh } = useSubscriptionAccess();

  if (loading) {
    return (
      <div className="plans-loading">
        <Loader2 size={22} className="animate-spin" />
      </div>
    );
  }

  if (hasAccess) return <>{children}</>;

  return (
    <div className="subscribe-page">
      <div className="page-head">
        <div>
          <h2><Lock size={18} style={{ marginRight: 6, verticalAlign: -2 }} />Subscription required</h2>
          <p>This feature needs an active plan. Choose one below to continue.</p>
        </div>
      </div>
      <PlansPanel compact showAddons={false} onSubscribed={() => refresh()} />
    </div>
  );
};

export default SubscriptionGate;
